/**
 * @module types/settings/referenceLine
 * @description 高级参考线配置（存储字段名 `reference_line`，上传为数组）
 */

export interface IReferenceLineStyle {
  type?: string;
  color?: string;
}

export interface IReferenceLineValue {
  type?: string;
  number?: string | number;
}

export interface IReferenceLineItem {
  style?: IReferenceLineStyle;
  value?: IReferenceLineValue;
  label?: string;
}

/** 新增一条参考线时的表单初始值 */
export const DEFAULT_REFERENCE_LINE_ITEM: IReferenceLineItem = {
  style: { color: '#6A6D7E', type: 'dashed' },
  value: { type: 'fixed', number: '' },
  label: '',
};

/** 空列表的模块级默认引用 */
export const REFERENCE_LINE_DEFAULT: IReferenceLineItem[] = Object.freeze(
  [],
) as IReferenceLineItem[];
